import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopMetaByKeyQueryVariables = Types.Exact<{
  key: Types.Scalars['String']['input'];
}>;

export type ShopMetaByKeyQueryResponse = {
  shopMetaByKey?: Types.Maybe<
    Pick<Types.ShopMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>
  >;
};

export const ShopMetaByKeyDocument = `
    query ShopMetaByKey($key: String!) {
  shopMetaByKey(key: $key) {
    createdAt
    id
    key
    updatedAt
    value
  }
}
    `;

export const useShopMetaByKeyQuery = <TData = ShopMetaByKeyQueryResponse, TError = unknown>(
  variables: ShopMetaByKeyQueryVariables,
  options?: UseQueryOptions<ShopMetaByKeyQueryResponse, TError, TData>,
) => {
  return useQuery<ShopMetaByKeyQueryResponse, TError, TData>(
    ['ShopMetaByKey', variables],
    appFetcher<ShopMetaByKeyQueryResponse, ShopMetaByKeyQueryVariables>(
      ShopMetaByKeyDocument,
      variables,
    ),
    options,
  );
};

useShopMetaByKeyQuery.getKey = (variables: ShopMetaByKeyQueryVariables) => [
  'ShopMetaByKey',
  variables,
];
